<template>
	<div class="booking-form__section-heading flex-horizontal" @click="$emit('toggleVisibility')" :id="anchor" :disabled="!canVisible">
		<div class="heading-data flex-horizontal">
			<h2 class="heading-data-label heading-section booking-bold">{{ caption }}</h2>
			<span class="heading-data-selection heading-section booking-regular">{{ selection }}</span>
		</div>
		<div class="heading-controls">
			<button class="button button__booking button__booking-small" v-if="canVisible">
				{{ $t('edit') }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		caption: {
			type: String,
		},
		anchor: {
			type: String,
		},
		selection: {
			type: String,
		},
		canVisible: {
			type: Boolean,
		},
	},
}
</script>
